'use client';

import React from 'react';
import { PlatformContext } from '../context/PlatformContext';
import { PlatformPrimitives } from '../types/PlatformPrimitives';
import { WebDefaults } from '../constants/WebDefaults';

/**
 * @group Components

@summary
<blockquote>Provider component that supplies platform primitives to universal components.</blockquote>

@example
```typescript
<PlatformProvider components={webPrimitives}>
  <Logo size={32} />
</PlatformProvider>
```
 * @internal
 */
export const PlatformProvider: React.FC<{
  children: React.ReactNode;
  components?: Partial<PlatformPrimitives>;
}> = ({ children, components = {} }) => {
  const mergedComponents = {
    ...WebDefaults,
    ...components
  };

  return (
    <PlatformContext.Provider value={mergedComponents}>
      {children}
    </PlatformContext.Provider>
  );
};